import { Box, Flex } from '@mantine/core';

import { useUser } from '../../../hooks';
import { PRIVACY_POLICY_URL } from '../../../common/constants';

import { useAuth0 } from '@auth0/auth0-react';
import { Anchor, Divider, Drawer, Image, Text } from '@mantine/core';
import useValidatedSearchParams from '../../../router/useValidatedSearchParams';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import classes from './User.module.css';

declare const __APP_VERSION__: string;

const UserPanel = () => {
  const { t } = useTranslation();
  const { user: authUser, logout } = useAuth0();
  const { data: user } = useUser();
  const {
    setValidatedParam,
    validatedParams,
    SEARCH_PARAMS_KEYS: { USER_PANEL },
  } = useValidatedSearchParams();

  const navigate = useNavigate();

  const fullName = `${user?.firstName} ${user?.lastName}`;

  const logoutUser = async () => {
    await logout({
      logoutParams: { returnTo: window.location.origin },
    });
  };

  return (
    <>
      <Box
        className={classes.userImageWrapper}
        onClick={() => {
          setValidatedParam(USER_PANEL, 'true');
        }}
      >
        <Image
          src={authUser?.picture}
          alt="user"
          radius="xl"
          referrerPolicy="no-referrer"
        />
      </Box>
      <Drawer
        opened={!!validatedParams[USER_PANEL]}
        onClose={() => setValidatedParam(USER_PANEL, null)}
        position="right"
        size="400px"
        styles={{
          header: { display: 'none' },
        }}
      >
        <Flex gap="md" align="center" mt="md">
          <Image
            src={authUser?.picture}
            alt="user"
            radius="xl"
            width={54}
            height={54}
            referrerPolicy="no-referrer"
          />
          <Box>
            <Text>{fullName}</Text>
            <Text>{user?.email}</Text>
          </Box>
        </Flex>
        <Divider color="dark.6" mt="md" mb="md" />
        <Flex direction="column">
          <Anchor className={classes.link} onClick={() => navigate('/admin')}>
            {t('nav.settings')}
          </Anchor>

          <Anchor
            className={classes.link}
            onClick={() => window.open(PRIVACY_POLICY_URL, '_blank')}
          >
            {t('nav.privacy')}
          </Anchor>

          <Anchor className={classes.link} onClick={logoutUser}>
            {t('nav.logout')}
          </Anchor>
        </Flex>

        <Flex pos="fixed" bottom={24} w="92%" direction="column">
          <Divider color="dark.6" mt="md" mb="md" />
          <Flex justify="space-between">
            <Text c="dark.6">
              {t('nav.version', { version: __APP_VERSION__ })}
            </Text>
            <Text c="dark.6">{t('nav.poweredByLiveEO')}</Text>
          </Flex>
        </Flex>
      </Drawer>
    </>
  );
};

export default UserPanel;
